import React, { useState } from 'react';
import { Container, Tabs, Tab, Box, Stack } from '@mui/material';

import Dashboard from './pages/Dashboard';
import Routines from './pages/Routines';
import Workout from './pages/Workout';
import History from './pages/History';
import Progress from './pages/Progress';
import Nutrition from './pages/Nutrition';

import { useWorkoutStore } from './store/workoutStore';

const FitnessApp = () => {
  const [tab, setTab] = useState(0);
  const startWorkout = useWorkoutStore((state) => state.startWorkout);
  const activeWorkout = useWorkoutStore((state) => state.activeWorkout);

  const [workoutState, setWorkoutState] = useState(() => {
    const aw = useWorkoutStore.getState().activeWorkout;
    return aw ? { routineId: aw.routineId, dayId: aw.dayId } : null;
  });

  const handleStartWorkout = (routineId, dayId) => {
    startWorkout(routineId, dayId);
    setWorkoutState({ routineId, dayId });
  };

  const handleCloseWorkout = () => {
    setWorkoutState(null);
  };

  if (activeWorkout && workoutState) {
    return (
      <Workout
        routineId={workoutState.routineId}
        dayId={workoutState.dayId}
        onClose={handleCloseWorkout}
      />
    );
  }

  return (
    <Container sx={{ mt: 4, pb: 6 }}>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 3 }}
      >
        <Tab label="Dashboard" />
        <Tab label="Rutinas" />
        <Tab label="Historial" />
        <Tab label="Progreso" />
        <Tab label="Nutrición" />
      </Tabs>

      <Box>
        {tab === 0 && <Dashboard onStartWorkout={handleStartWorkout} />}
        {tab === 1 && <Routines />}
        {tab === 2 && <History />}
        {tab === 3 && <Progress />}
        {tab === 4 && <Nutrition />}
      </Box>
    </Container>
  );
};

export default FitnessApp;
